import { render } from "./DemoBoard.vue?vue&type=template&id=5c604788&scoped=true"
import script from "./DemoBoard.vue?vue&type=script&lang=js"
export * from "./DemoBoard.vue?vue&type=script&lang=js"

import "./DemoBoard.vue?vue&type=style&index=0&id=5c604788&scoped=true&lang=css"

import exportComponent from "/Users/victoriengarrigues/Documents/Moonarch-DEV/code/moonarch-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c604788"]])

export default __exports__